import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import { SET_REQUIREDFILTER } from './constants';

const initialState = {
  actionRequiredFilter: false,
};

export const actionRequiredFilterReducer = createReducer(initialState, {
  [SET_REQUIREDFILTER]: (state, action) => {
    return {
      ...state,
      actionRequiredFilter: action.payload,
    };
  },
});
